import { Fragment } from 'react';

import { cn, iaRa } from 'lib/helpers/utility';

import DocText from '../DocText';
import { DOC_TEXT } from '../lib/docStyles';

const NBSP = '\u00a0';

const ChipLine = ({ chips, className }) => {
  const visibleChips = iaRa(chips).filter((chip) => chip?.label || chip?.value);

  if (!visibleChips.length) return null;

  return (
    <DocText size="xs" className={cn(DOC_TEXT.headerBody, className)}>
      {visibleChips.map((chip, index) => (
        <Fragment key={`${chip.label}-${chip.value}-${index}`}>
          {index > 0 && <span className="text-neutral-500"> · </span>}
          {chip.label && <span>{chip.label.replace(/ $/, NBSP)}</span>}
          {chip.value && <span className="font-700 text-neutral-900">{chip.value}</span>}
        </Fragment>
      ))}
    </DocText>
  );
};

export default ChipLine;
